'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Root } from '@radix-ui/react-accordion';
import { cn } from '../../utils/cn';
import { AccordionContext } from './Context';
const Accordion = ({ className, children, disabled = false, flush, ...props }) => {
    return (_jsx(Root, { className: cn('w-full', disabled && 'pointer-events-none opacity-50', flush ? 'space-y-0' : 'space-y-4', className), ...props, children: _jsx(AccordionContext.Provider, { value: { flush }, children: children }) }));
};
export { Accordion };
